function deferFilterjQuery() {
  if (window.jQuery) {
      var $ = window.jQuery;
      $(function(){
      // $(document).ready(function() {
        // On load/reload
        var pt_on_load = function() {
          // Accordion
          

          // Search
          $('.pt-display-search').not('.has_group_selected').find('input.fm-search-box').show();

          // Drop downs
          $('.pt-display-dropdown').each(function( index ) {
//                 $(this).find('h4').after($(this).find('.filter-clear'));
          });

          $('.pt-display-dropdown .scroll-content').each(function( index ) {
              if($(this).parent().find('.menu-trigger').length === 0) {
                  if($(this).find('li.selected').length) {
                      var selected = $.map(
                          $(this).find('li.selected a'),
                              function(element){
                                  return $(element).text();
                              }
                      ).join(", ");

                      if (selected.length < 30) {
//                             $(this).before('<div class="menu-trigger">' + selected +'</div>');
                        $(this).before('<div class="menu-trigger" tabindex="0" aria-label="Filter menu">' + $(this).closest('.filter-group').find('h4').text() +'</div>');
                      } else {
                          $(this).before('<div class="menu-trigger" tabindex="0" aria-label="Filter menu">' + $(this).find('li.selected').length + ' Selected </div>');
                      }
                  }
                  else {
                      $(this).before('<div class="menu-trigger" tabindex="0" aria-label="Filter menu">'+ $(this).closest('.filter-group').find('h4').text() +'</div>');
                  }
              }
          });

          //Sticky Mode
          

          // View more
          
          $('.filter-group ul:not(.has_selected)').each(function(){
            var max = 8;
            if ($(this).find("li:not(.selected)").length > (max+1)) {
              $(this).find('li:gt('+(max-1)+'):not(.selected)')
              .hide()
              .end()
              .append(
                $('<li class="view-more-link"><a href="javascript:;">View More...</a></li>').click( function(){
                    $(this).siblings(':hidden').slideDown(100).end().slideUp(100);
                })
              );
            }
          });
          

          $('.filter-menu li a').attr('title', function() {
            return ($(this).closest('li').hasClass('selected') ? "Clear filter: " : "Add filter: ") + $(this).text();
          });

          // Handle nested filters
          var splitPath = function(url) {
            var splitUrl =  url.split('?')[0].split('#')[0].split('/');
            return splitUrl;
          }

          var getCollection = function(url) {
            var splitUrl = splitPath(url);
            return splitUrl[2];
          }

          var getTags = function(url) {
            var splitUrl = splitPath(url);
            return (splitUrl[3] || '').split('+');
          }

          var getCommonCollection = function(url_top, url_nested) {
            var collection_top = getCollection(url_top);
            var collection_nested = getCollection(url_nested);
            if (collection_top !== collection_nested) {
              return 'all';
            }
            return collection_top;
          }

          var getCommonTags = function(url_top, url_nested) {
            var tags_top = getTags(url_top);
            var tags_nested = getTags(url_nested);

            return tags_top.filter(function(n) {
              return tags_nested.indexOf(n) > -1;
            });
          }

          var getCommonUrl = function(url_top, url_nested) {
            var val = '/collections/' + getCommonCollection(url_top, url_nested) + '/' + getCommonTags(url_top, url_nested).join('+');

            var lastChar = val.slice(-1);
                  if (lastChar == '/') {
                  val = val.slice(0, -1);
              }

            return val;
          }

          var clearNestedParent = $('.pt-display-nested').prev().each(function() {
            var clearNested = $(this).next().find('a.filter-clear').attr('href');
            if (!clearNested) return;
            var clearLink = $(this).find('a.filter-clear');
            clearLink.attr('href', getCommonUrl(clearLink.attr('href'), clearNested))
            var filterLinks = $(this).find('li.selected .collection-name a').each(function() {
              $(this).attr('href', getCommonUrl($(this).attr('href'), clearNested))
            })
          })
        }

        pt_on_load();

        // Mobile filter button
        
          $(document).on('click', '.filter-menu .pt-mobile-header a#pt-nav-toggle', function(e){
            $('.filter-menu').toggleClass('pt-expand');
            $('.scroll-content.sort-content').hide();
            $('.pt-mobile-header .filter-group-sort-orders .scroll-content').hide();          
            });
            if($('.filter-menu').hasClass('pt-expand')){ 
              $('.all-filters .scroll-content').show();
            }
        

        // Accordion
        

        // Search
        $(document).on('keyup', '.filter-group input.fm-search-box', function () {
          var value = this.value.toLowerCase();
          $(this).closest('.filter-group').find('li').each(function () {
            if ($(this).text().toLowerCase().search(value) > -1) {
              $(this).show(100);
            } else {
              $(this).hide(100);
            }
          });
        });

        // Drop downs
        // $(document).on('click','.pt-display-dropdown .menu-trigger',function() {
        // $('.pt-display-dropdown .menu-trigger').click(function() {
        $('.view-more-link').click();
        $("body").delegate(".pt-display-dropdown .menu-trigger", "click", function(){
          if($(window).width() < 798 && !$(this).parent().hasClass('filter-group-sort-orders')){
            if($(this).hasClass('content-open')) {
              $(this).removeClass('content-open');
              $(this).next('.scroll-content').slideUp(100);
            } else {
              $('.pt-display-dropdown .menu-trigger').not(this).removeClass('content-open');
              $('.pt-display-dropdown .scroll-content').not(this).slideUp('fast');
              $(this).toggleClass('content-open');
              $(this).next('.scroll-content').slideToggle(100);
            }
          } else {
            console.log('Desktop.');
            $('.filter-menu').removeClass('pt-expand');          
            if($(this).hasClass('content-open')) {
              $(this).removeClass('content-open');
              $(this).next('.scroll-content').toggle();
            } else {
              $('.pt-display-dropdown .menu-trigger').not(this).removeClass('content-open');
              $('.pt-display-dropdown .menu-trigger').not(this).next('.scroll-content').hide();
              console.log('Open');
              //$('.pt-display-dropdown .scroll-content').not(this).slideUp(100);
              $(this).toggleClass('content-open');
              //$(this).next('.scroll-content').css('top', $(this).position().top + $(this).height() + 1).css('left', $(this).position().left);
              //$(this).next('.scroll-content').slideToggle(100);
              $(this).next('.scroll-content').toggle();
              console.log('Loaded')

            }
          }
        });

//           $(document).on('mouseleave', '.pt-display-dropdown .scroll-content', function() {
//             $(this).slideUp('fast');
//             $(this).prev('.menu-trigger').removeClass('content-open');
//           });

        // Apply button
        

        // Ajax
        
        $.getScript("//www.aquariumcoop.com/cdn/shop/t/994/assets/jquery.pjax.js?v=138580039773092267901703139849").done(function(script, textStatus) {
          $body = $("body");
          $(document).pjax('body .filter-group a, body .pagination a', '#shopify-section-collection-sub-collections-template', { fragment: '#shopify-section-collection-sub-collections-template', timeout: 10000, scrollTo: false, push: true });
          $(document).on('pjax:start', function(){  
            $body.addClass("pt-ajax-loading"); 
            $('#shopify-section-collection-sub-collections-template').fadeTo('slow', 0.5); 
          });
          $(document).on('pjax:end', function(){ 
            $body.removeClass("pt-ajax-loading");
            $('#shopify-section-collection-sub-collections-template').fadeTo('fast', 1);
            pt_on_load();
            ; 
             console.log('End sort');
             loadMoreButton.init();
            $('#filtering_sorting').css('height',$('#filtering_sorting').outerHeight());
            if($(window).width() > 798) {
              setTimeout(function() {
                //Shopify.theme.jsProductThumbnail.initProductCarousels();
                $(window).trigger('resize');
                $('html, body').animate({
                  scrollTop: $("body").offset().top
                }, 250);
                var paginationLimit = $('.product__thumbnail').length;
                var totalProducts = parseInt($('.load_more_progress').attr('data-total-products'));
                $('.load_more_progress_text .products_showing').html(paginationLimit);
                $('.load_more_progress_bar > div').css('width',(paginationLimit/totalProducts)*100 + '%');
              },100);
            }
          });
        });
        
    });
    // $(window).on('resize', function (){
    //   var filters = $('body').find('.filter-group:not(.filter-group-sort-orders)');
    //   if($(this).width() < 798){
    //     if($('.mobile_filter_sidebar .filter_content').is(':empty')){
    //       $(".mobile_filter_sidebar .filter_content").append(filters);
    //     }
    //   } else {
    //     	$(".mobile_filter_sidebar .filter_content").empty();
    //       $('.desktop-filters .filter-menu').prepend(filters);
    //   }
    // });
    // $(document).on('click','#pt-nav-toggle', function(e){

    // $(document).on('click','.mobile_filter_sidebar .apply_filters,.mobile_filter_sidebar .close_sidebar', function(e){
    $("body").delegate(".mobile_filter_sidebar .apply_filters,.mobile_filter_sidebar .close_sidebar,.mobile_filter_sidebar .sidebar_bg", "click", function(e){  
      $('body,html').css({
        'overflow-x':'hidden',
        'overflow-y':'auto'
      });
      $('body').find('.mobile_filter_sidebar').removeClass('show');
    });

    // add sort by reviews
    function updateRatingSort(sort){
      console.log('sort', sort)
      let sort_attribute = '';
      if(sort.hasClass('selected')) {
        sort.removeClass('selected');
        sort_attribute = 'index';
      } else {
        sort.addClass('selected');
        sort_attribute = 'product_rating';
      }
      var $wrapper = $('.grid--view-items');

      $wrapper.find('.grid__item').sort(function(a, b) {
        return +b.dataset[sort_attribute] -  +a.dataset[sort_attribute];
      })
      .appendTo($wrapper);
    }
    $('body').on('click', '.rating-sort', function(e){
      const li_container = $(this).parents('li.active');
      updateRatingSort(li_container);
    })
  }
  else {
      setTimeout(function() { deferFilterjQuery() }, 50);
  }
}

deferFilterjQuery();